export enum Tap2GOStatus {
  request = 'request',
  start = 'start',
  check = 'check',
  success = 'success',
  failure = 'failure',
}

export enum Tap2GOTicketTicketStatus {
  valid = 'valid',
  checked = 'checked',
  cancelled = 'cancelled',
}

interface IGoodServiceEvent {
  datetime_tz: string
  id: number
  codeUrl: string
  name: string
  policy: {
    code: string
  }
  location: {
    address: string
    latitude: string
    longitude: string
  }
}

interface IGoodServicePrice {
  amount: string
  currency: string
  formatted: string
  symbol: string
}

export interface IGoodServiceTicketData {
  customColor?: string
  dateEntry_tz?: string
  event: IGoodServiceEvent
  emissionDate_tz: string
  hasVaultEnabled: boolean
  locationName: string
  openDateEvent_tz: string
  notes: string
  price: IGoodServicePrice
  presale: IGoodServicePrice
  secret: string
  status: string
  statusLabel: string
  receiptsUri: string
  validFrom: string
  validFrom_tz: string
  validTo: string
  validTo_tz: string
  totalPrice: IGoodServicePrice
  webDetails: string
}

export interface ISelectableGoodServiceTicket {
  idx: number
  data: IGoodServiceTicketData
}

export interface ITap2GOData {
  otp: {
    value: string
    timeElapsed: number
    validFrom: number
    validTo: number
  }
  requestCode: string
}
